/* eslint-disable class-methods-use-this */
import React from 'react'

import Paper from 'material-ui/Paper';

import NewWifi from '../../../../components/wifi/NewWifi';
import WifiList from '../../../../components/wifi/WifiList';

import { wifi as ROLES_CONFIG } from '../../../../config/roles';

export default class WifiManagement extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.newwifi.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-5 col-11 ml-3vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <NewWifi />
              </Paper> 
            : null
          }
          {
            ROLES_CONFIG.wifilist.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <WifiList />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/Wifi/WifiManagement.js